import { InLifeLayout } from '@in-life/components/Layout';
import { clearInLifeOrderAndRedirectToMyAccount } from '@in-life/utils/clearInLifeOrder';
import { captureException as sentryCaptureException } from '@sentry/react';
import {
  BodyText,
  Button,
  Card,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';
import SpotUnavailableLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-unavailable-light.svg';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { useLoader } from '@hooks/useLoader';
import { RequestState } from '@src/types/index';

const InLifeErrorBoundary = () => {
  const error = useRouteError();
  const { setRequestState } = useLoader();

  useEffect(() => {
    sentryCaptureException(error);
    setRequestState(RequestState.success);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleBackToMyAccount = () => {
    clearInLifeOrderAndRedirectToMyAccount();
  };

  return (
    <InLifeLayout isErrorBoundary>
      <Flex className="wrapper" direction="column" spacing="xl">
        <Card
          variant="subtle"
          spacing="xl"
          alignItems="center"
          maxWidth={{ mobile: '100%', desktop: '800px' }}
          direction={{
            mobile: 'column',
            desktop: 'row',
          }}
        >
          <img
            src={SpotUnavailableLight}
            alt="Spot Unavailable"
            width={130}
            height={170}
            style={{ margin: '0 auto' }}
          />
          <Flex direction="column" spacing="lg">
            <Heading as="h1">Something's gone wrong on our end</Heading>
            {error instanceof Error && <BodyText>{error.message}</BodyText>}
            <BodyText>
              Don't worry, your details are safe. The best thing to do right now
              is head back home and try again.
            </BodyText>
          </Flex>
        </Card>
        <Button
          variant="outline"
          onClick={handleBackToMyAccount}
          marginBottom="500"
          style={{ width: 'fit-content' }}
        >
          Back to home
        </Button>
      </Flex>
    </InLifeLayout>
  );
};

export { InLifeErrorBoundary };
